import VolumeContextBase from "./volumeContextBase";
import { getDefaultMeasurementIndex, getMeasurementData } from "./octUtils";

export default class SpectralisContext extends VolumeContextBase {
  constructor(group, exam, imgKey) {
    super(group, exam, "spectralisBrowserBody", "Spectralis Browser", imgKey);
    
    this.loadComposite = false;
    this.loadHD = false;

    this.isMeasuring = false;
    this.measureData = null;

    this.showThicknessMap = false;

    this.thicknessMapMaxThicknessUm = 600;

    this.drawAllSlices = true;
  }
  
  toggleMeasuring() {
    if (!this.isMeasuring){
      this.setDefaultMeasurement();
      if (this.measureData) this.isMeasuring = true;
    } else {
      this.measureData = null;
      this.isMeasuring = false;
    }
  }
  setDefaultMeasurement(){
    let index = getDefaultMeasurementIndex(this.sliceInfo);
    this.setMeasurementIndex(index);
  }
  setMeasurementIndex(index) {
    this.measureData = getMeasurementData(index, this.sliceCurrent, this.sliceInfo);
  }
  toggleShowThicknessMap(){
    if (this.showThicknessMap) {
      this.showThicknessMap = false;
      this.drawAllSlices = true;
    } else {
      this.showThicknessMap = true;
      this.drawAllSlices = false;
    }
  }
}